// The blocks of the Vista Tech logo's arrow, measured off src/logo/lo.png (1 unit = 1 px of
// that file, x from the stem's centre, y up). `step` is the join step that lays the block;
// both the 3D arrow and its flat stand-in (PathToPlacement.tsx) draw from this list.
export type ArrowBlock = { x: number; y: number; w: number; h: number; turn: 0 | 45; color: string; step: number; z: number };

export const PLUM = '#2b2240';
export const GOLD = '#F0B429';
export const ORANGE = '#FF6535';

export const ARROW_BLOCKS: ArrowBlock[] = [
  { x: 0, y: -48, w: 25, h: 24, turn: 0, color: ORANGE, step: 0, z: 0 },
  { x: 0, y: -23, w: 25, h: 24, turn: 0, color: PLUM, step: 1, z: 0 },
  { x: 0, y: 2, w: 25, h: 24, turn: 0, color: PLUM, step: 2, z: 0 },
  { x: -17, y: 34, w: 25, h: 24, turn: 45, color: PLUM, step: 3, z: 1 },
  { x: 17, y: 34, w: 25, h: 24, turn: 45, color: PLUM, step: 3, z: 1 },
  { x: -35, y: 16, w: 25, h: 24, turn: 45, color: PLUM, step: 3, z: 1 },
  { x: 35, y: 16, w: 25, h: 24, turn: 45, color: PLUM, step: 3, z: 1 },
  { x: -53, y: -2, w: 25, h: 24, turn: 45, color: ORANGE, step: 3, z: 1 },
  { x: 53, y: -2, w: 25, h: 24, turn: 45, color: ORANGE, step: 3, z: 1 },
  { x: 0, y: 25, w: 20, h: 20, turn: 45, color: GOLD, step: 4, z: 0 },
  { x: 0, y: 49, w: 28, h: 28, turn: 45, color: GOLD, step: 4, z: 0 },
];

export const JOIN_STEPS = 5;
